"use strict";
exports.__esModule = true;
exports.Scale = exports.Currency = void 0;
var Currency;
(function (Currency) {
    Currency["EUR"] = "EUR";
    Currency["DZD"] = "DZD";
    Currency["AOA"] = "AOA";
    Currency["XCD"] = "XCD";
    Currency["ARS"] = "ARS";
    Currency["AMD"] = "AMD";
    Currency["AWG"] = "AWG";
    Currency["AUD"] = "AUD";
    Currency["AZN"] = "AZN";
    Currency["BSD"] = "BSD";
    Currency["BHD"] = "BHD";
    Currency["BDT"] = "BDT";
    Currency["BBD"] = "BBD";
    Currency["BYR"] = "BYR";
    Currency["BZD"] = "BZD";
    Currency["XOF"] = "XOF";
    Currency["BMD"] = "BMD";
    Currency["BTN"] = "BTN";
    Currency["BOB"] = "BOB";
    Currency["BAM"] = "BAM";
    Currency["BWP"] = "BWP";
    Currency["BRL"] = "BRL";
    Currency["BND"] = "BND";
    Currency["BGN"] = "BGN";
    Currency["BIF"] = "BIF";
    Currency["KHR"] = "KHR";
    Currency["XAF"] = "XAF";
    Currency["CAD"] = "CAD";
    Currency["CVE"] = "CVE";
    Currency["KYD"] = "KYD";
    Currency["CLP"] = "CLP";
    Currency["CNY"] = "CNY";
    Currency["COP"] = "COP";
    Currency["KMF"] = "KMF";
    Currency["CDF"] = "CDF";
    Currency["NZD"] = "NZD";
    Currency["CRC"] = "CRC";
    Currency["HRK"] = "HRK";
    Currency["CUC"] = "CUC";
    Currency["CYP"] = "CYP";
    Currency["CZK"] = "CZK";
    Currency["DKK"] = "DKK";
    Currency["DJF"] = "DJF";
    Currency["DOP"] = "DOP";
    Currency["USD"] = "USD";
    Currency["EGP"] = "EGP";
    Currency["ERN"] = "ERN";
    Currency["EEK"] = "EEK";
    Currency["ETB"] = "ETB";
    Currency["FKP"] = "FKP";
    Currency["FJD"] = "FJD";
    Currency["XPF"] = "XPF";
    Currency["GMD"] = "GMD";
    Currency["GEL"] = "GEL";
    Currency["GHC"] = "GHC";
    Currency["GHS"] = "GHS";
    Currency["GIP"] = "GIP";
    Currency["GTQ"] = "GTQ";
    Currency["GNF"] = "GNF";
    Currency["GYD"] = "GYD";
    Currency["HTG"] = "HTG";
    Currency["HNL"] = "HNL";
    Currency["HKD"] = "HKD";
    Currency["HUF"] = "HUF";
    Currency["ISK"] = "ISK";
    Currency["INR"] = "INR";
    Currency["IDR"] = "IDR";
    Currency["IRR"] = "IRR";
    Currency["IQD"] = "IQD";
    Currency["GBP"] = "GBP";
    Currency["GBX"] = "GBX";
    Currency["ILS"] = "ILS";
    Currency["JMD"] = "JMD";
    Currency["JPY"] = "JPY";
    Currency["JOD"] = "JOD";
    Currency["KZT"] = "KZT";
    Currency["KES"] = "KES";
    Currency["KPW"] = "KPW";
    Currency["KRW"] = "KRW";
    Currency["KWD"] = "KWD";
    Currency["KGS"] = "KGS";
    Currency["LAK"] = "LAK";
    Currency["LVL"] = "LVL";
    Currency["LBP"] = "LBP";
    Currency["LSL"] = "LSL";
    Currency["LRD"] = "LRD";
    Currency["LYD"] = "LYD";
    Currency["CHF"] = "CHF";
    Currency["LTL"] = "LTL";
    Currency["MOP"] = "MOP";
    Currency["MKD"] = "MKD";
    Currency["MGA"] = "MGA";
    Currency["MWK"] = "MWK";
    Currency["MYR"] = "MYR";
    Currency["MVR"] = "MVR";
    Currency["MTL"] = "MTL";
    Currency["MRO"] = "MRO";
    Currency["MUR"] = "MUR";
    Currency["MXN"] = "MXN";
    Currency["MDL"] = "MDL";
    Currency["MNT"] = "MNT";
    Currency["MAD"] = "MAD";
    Currency["MZN"] = "MZN";
    Currency["MMK"] = "MMK";
    Currency["NAD"] = "NAD";
    Currency["NPR"] = "NPR";
    Currency["ANG"] = "ANG";
    Currency["NIO"] = "NIO";
    Currency["NGN"] = "NGN";
    Currency["NOK"] = "NOK";
    Currency["OMR"] = "OMR";
    Currency["PKR"] = "PKR";
    Currency["PAB"] = "PAB";
    Currency["PGK"] = "PGK";
    Currency["PYG"] = "PYG";
    Currency["PEN"] = "PEN";
    Currency["PHP"] = "PHP";
    Currency["PLN"] = "PLN";
    Currency["QAR"] = "QAR";
    Currency["RON"] = "RON";
    Currency["RUB"] = "RUB";
    Currency["RWF"] = "RWF";
    Currency["SHP"] = "SHP";
    Currency["WST"] = "WST";
    Currency["STD"] = "STD";
    Currency["SAR"] = "SAR";
    Currency["RSD"] = "RSD";
    Currency["SCR"] = "SCR";
    Currency["SLL"] = "SLL";
    Currency["SGD"] = "SGD";
    Currency["SKK"] = "SKK";
    Currency["SBD"] = "SBD";
    Currency["SOS"] = "SOS";
    Currency["ZAR"] = "ZAR";
    Currency["LKR"] = "LKR";
    Currency["SDD"] = "SDD";
    Currency["SRD"] = "SRD";
    Currency["SZL"] = "SZL";
    Currency["SEK"] = "SEK";
    Currency["SYP"] = "SYP";
    Currency["TWD"] = "TWD";
    Currency["TJS"] = "TJS";
    Currency["TZS"] = "TZS";
    Currency["THB"] = "THB";
    Currency["TOP"] = "TOP";
    Currency["TTD"] = "TTD";
    Currency["TND"] = "TND";
    Currency["TRY"] = "TRY";
    Currency["TMM"] = "TMM";
    Currency["UGX"] = "UGX";
    Currency["UAH"] = "UAH";
    Currency["AED"] = "AED";
    Currency["UYU"] = "UYU";
    Currency["UZS"] = "UZS";
    Currency["VUV"] = "VUV";
    Currency["VEB"] = "VEB";
    Currency["VND"] = "VND";
    Currency["YER"] = "YER";
    Currency["ZMK"] = "ZMK";
    Currency["ZMW"] = "ZMW";
    Currency["ZWD"] = "ZWD";
    Currency["ZWL"] = "ZWL";
    Currency["XXX"] = "XXX";
})(Currency = exports.Currency || (exports.Currency = {}));
var Scale;
(function (Scale) {
    Scale[Scale["Ones"] = 1] = "Ones";
    Scale[Scale["Tens"] = 10] = "Tens";
    Scale[Scale["Hundreds"] = 100] = "Hundreds";
    Scale[Scale["Thousands"] = 1000] = "Thousands";
    Scale[Scale["TensOfThousands"] = 10000] = "TensOfThousands";
    Scale[Scale["HundredsOfThousands"] = 100000] = "HundredsOfThousands";
    Scale[Scale["Millions"] = 1000000] = "Millions";
    Scale[Scale["TensOfMillions"] = 10000000] = "TensOfMillions";
    Scale[Scale["HundredsOfMillions"] = 100000000] = "HundredsOfMillions";
    Scale[Scale["Billions"] = 1000000000] = "Billions";
    Scale[Scale["TensOfBillions"] = 10000000000] = "TensOfBillions";
    Scale[Scale["HundredsOfBillions"] = 100000000000] = "HundredsOfBillions";
    Scale[Scale["Trillions"] = 1000000000000] = "Trillions";
    Scale[Scale["TensOfTrillions"] = 10000000000000] = "TensOfTrillions";
    Scale[Scale["HundredsOfTrillions"] = 100000000000000] = "HundredsOfTrillions";
    Scale[Scale["Quadrillion"] = 1000000000000000] = "Quadrillion";
})(Scale = exports.Scale || (exports.Scale = {}));
